import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../../Shared/Icon/Icon'

const PriceOfferDecisionButtons = ({ offerId, conversationId, onPriceOfferDecisionSuccess }) => {
  const onPriceOfferDecision = (e) => {
    e.preventDefault()

    axios.post(`/api/internal/price_offers/${offerId}`, { status: e.target.value, conversation_id: conversationId })
      .then(onPriceOfferDecisionSuccess)
      .catch(onPriceOfferDecisionFailure)
  }

  const onPriceOfferDecisionFailure = (error) => {
    return App.events.publish('app:notification:flash:error', error.response.data.error)
  }

  return (
    <span>
      <button className="button button--alt button--horizontally-spaced" onClick={onPriceOfferDecision} value="declined">
        <Icon type="exclamation-triangle" />
        Decline this offer
      </button>
      <button className="button" onClick={onPriceOfferDecision} value="accepted">
        <Icon type={['far', 'check-circle']} />
        Accept this offer
      </button>
    </span>
  )
}

PriceOfferDecisionButtons.propTypes = {
  offerId: PropTypes.number.isRequired,
  conversationId: PropTypes.string.isRequired,
  onPriceOfferDecisionSuccess: PropTypes.func.isRequired,
}

export default PriceOfferDecisionButtons
